import React from 'react';
import { connect } from 'react-redux';
import IconBar from './IconBar';

const Sidebar = ({ isOpen, className, id = 'sidebar', style }) => (
  <nav
    id={id}
    style={style}
    className={[
      'd-flex bg-dark px-0 position-fixed h-100',
      isOpen ? 'open' : '',
      // Prevent header from being printed on .print()
      'd-print-none',
      className,
    ].join(' ')}
  >
    <div id="bg-icons" />
    <IconBar />
  </nav>
);

const mapStateToProps = (store) => ({
  isOpen: store.modals.sidebarOpen,
});

export default connect(mapStateToProps)(Sidebar);
